import { jsx as _jsx } from "react/jsx-runtime";
import { ASSETS } from "../../assets";
import { SpinWrapper } from "./SpinningLoader.styles";
export var SpinningLoader = function (_a) {
    var width = _a.width, height = _a.height;
    return (_jsx(SpinWrapper, { "$width": width, "$height": height, children: _jsx("img", { src: ASSETS.Spinner, alt: "spinner" }) }));
};
